export enum Operator {
  And = 'And',
  Or = 'Or'
}
